import { Badge, Box, Typography } from '@material-ui/core'
import React from 'react'
import ContentFilterValues from 'src/model/ContentFilter';
import FilterListIcon from "@material-ui/icons/FilterList";
import { useIntl } from 'react-intl';
import pageMessages from "../../../messages";
import contentMessages from "../../messages";

function FilterAccordionHeader({ expanded, getValues }: { expanded: boolean, getValues: any }) {

  const { formatMessage } = useIntl();

  const countActiveFilters = (values: ContentFilterValues) => {
    return Object.keys(values).reduce((acc: number, key: string) => {
      if (
        values[key as keyof ContentFilterValues] &&
        key !== "showMFWOriginals" &&
        key !== "showORGOriginals" &&
        key !== "showPublic" &&
        key !== "showPremium" &&
        key !== "isLockedContentDisplayed" &&
        key !== "showMyMfwNet"
      ) {
        if (
          values[key as keyof ContentFilterValues] === "string" ||
          key === "marketplaceMinPrice" ||
          key === "marketplaceMaxPrice" ||
          key === "sortContent"
        ) {
          acc += 1;
        } else {
          //@ts-ignore
          acc += values[key as keyof ContentFilterValues]?.length | 0;
        }
      }
      return acc;
    }, 0);
  };
  return (
    <Box display="flex" alignItems="center">
      <Box mr={2}>
        <Badge badgeContent={countActiveFilters(getValues())} color="primary">
          <FilterListIcon color="primary" />
        </Badge>
      </Box>
      <Box>
        <Typography variant="body1">{formatMessage(contentMessages.filters)}</Typography>
        <Typography variant="body2">
          {formatMessage(pageMessages.click_to)}
          {expanded ? formatMessage(pageMessages.collaps) : formatMessage(pageMessages.expand)}
        </Typography>
      </Box>
    </Box>
  )
}

export default FilterAccordionHeader